// alias: radarId
export default {
  rickAlias: 'rick'
}
